// extracted by mini-css-extract-plugin
export var active = "Modal-module--active--c2f9d";
export var core = "Modal-module--core--346ce";
export var visible = "Modal-module--visible--3952d";